/* ============================================================
   GUIA DE TALLAS EN MODAL (17 ago 2026)

   Al pulsar "Guía de tallas" se abre una ventana centrada con la tabla,
   como en paulina-jimenez.com, en vez del acordeon plegado que habia.

   ⚠️ LA TABLA SE CLONA, NO SE DUPLICA. El origen sigue siendo el metafield
   `custom.guia_tallas` que inyecta pn-rebaja-cards.liquid dentro del
   acordeon `[data-guia]`. Ese acordeon se esconde por CSS pero SIGUE EN EL
   HTML a proposito: es de donde se lee. Si se quita del Liquid, el modal
   se queda vacio.

   ⚠️ La tabla se busca CADA VEZ que se abre, no una sola vez al cargar.
   pn-rebaja-cards la inyecta con un setInterval y puede no estar lista
   cuando corre este script.
   ============================================================ */
(function () {
  'use strict';

  var fondo = null;

  function tablaOrigen() {
    var ac = document.querySelector('.producto-nazalea__acordeon[data-guia]');
    if (ac) {
      var cuerpo = ac.querySelector('.producto-nazalea__acordeon-cuerpo');
      if (cuerpo && cuerpo.innerHTML.trim()) { return cuerpo.innerHTML; }
    }
    var t = document.querySelector('table.pn-tallas');
    if (t) {
      var w = t.closest('.pn-tallas__wrap');
      return (w || t).outerHTML;
    }
    return null;
  }

  function crear() {
    if (fondo) { return fondo; }
    fondo = document.createElement('div');
    fondo.className = 'pn-guia-fondo';
    fondo.setAttribute('role', 'dialog');
    fondo.setAttribute('aria-modal', 'true');
    fondo.innerHTML =
      '<div class="pn-guia-caja">' +
        '<button type="button" class="pn-guia-cerrar" aria-label="Cerrar">&times;</button>' +
        '<h2 class="pn-guia-titulo"></h2>' +
        '<p class="pn-guia-sub">Guías de tallas</p>' +
        '<div class="pn-guia-cuerpo"></div>' +
      '</div>';
    document.body.appendChild(fondo);

    fondo.addEventListener('click', function (e) {
      if (e.target === fondo || (e.target.closest && e.target.closest('.pn-guia-cerrar'))) { cerrar(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { cerrar(); }
    });
    return fondo;
  }

  function abrir() {
    var f = crear();
    var html = tablaOrigen();
    if (!html) { return; }
    var t = document.querySelector('.producto-nazalea__titulo');
    f.querySelector('.pn-guia-titulo').textContent = t ? t.textContent.trim() : '';
    f.querySelector('.pn-guia-cuerpo').innerHTML = html;
    f.classList.add('pn-abierto');
    document.documentElement.style.overflow = 'hidden';
  }

  function cerrar() {
    if (!fondo) { return; }
    fondo.classList.remove('pn-abierto');
    document.documentElement.style.overflow = '';
  }

  function enganchar() {
    var btns = document.querySelectorAll('.producto-nazalea__guia');
    Array.prototype.forEach.call(btns, function (b) {
      if (b.dataset.pnGuia === '1') { return; }
      b.dataset.pnGuia = '1';
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        abrir();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enganchar);
  } else {
    enganchar();
  }
  document.addEventListener('shopify:section:load', enganchar);
  setTimeout(enganchar, 800);
})();